import React from 'react';
import {withRouter} from 'react-router-dom';

const HomeBreadcrumb = (props) => {
    const goHome = () => {
        props.history.push('/')
    }
    return (
        <>
            <div><i onClick={() => goHome()} className="fas fa-home"/></div>
        </>
    )
}//end class function
export default withRouter(HomeBreadcrumb);